import { faArrowLeft } from '@awesome.me/kit-f3dc60f0d0/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/ui/button';

import { useShouldHideHuddle } from '../../../modules/patientList/useShouldHideHuddle';

interface PatientListButtonProps {
  isInsights?: boolean;
  onClick: () => void;
}

export const PatientListButton = ({
  isInsights,
  onClick,
}: PatientListButtonProps) => {
  const hideHuddle = useShouldHideHuddle();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={onClick}
      className="vai-flex vai-items-center vai-gap-2 vai-text-white vai-bg-[#123059] hover:vai-bg-[#1a4a7a] vai-border-none vai-px-3 vai-py-2 vai-rounded-md"
    >
      <FontAwesomeIcon icon={faArrowLeft} className="vai-h-4 vai-w-4" />
      <span>
        {isInsights ? (
          <Trans>Back to Insights</Trans>
        ) : hideHuddle ? (
          <Trans>All Patients</Trans>
        ) : (
          <Trans>Dashboard</Trans>
        )}
      </span>
    </Button>
  );
};
